import React from 'react';
import { useParams } from 'react-router-dom';
import { DetailView } from '../../components/DetailView';
import { useClientSummary } from './useData';
import { ClientSummaryBody } from './components/ClientSummaryModal';
import { moduleConfig } from './config';
import { useAuth } from '../../contexts/AuthContext';

const ClientSummaryPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const idNum = id ? parseInt(id, 10) : 0;
  const { clientSummary, isLoading, mutate } = useClientSummary(idNum);
  const { can } = useAuth();
  const permissionModuleKey = moduleConfig.module.permissionModuleKey;
  const canEdit = !permissionModuleKey || can(permissionModuleKey, 'edit');

  return (
    <DetailView
      title={clientSummary ? moduleConfig.detail.getTitle(clientSummary) : undefined}
      backRoute={moduleConfig.module.route.list}
      editRoute={idNum ? moduleConfig.module.route.edit(idNum) : moduleConfig.module.route.list}
      canEdit={canEdit}
      sections={
        clientSummary
          ? [
              {
                title: '',
                content: (
                  <div className="mx-auto w-full max-w-7xl">
                    <ClientSummaryBody clientSummary={clientSummary} mutate={mutate} />
                  </div>
                ),
              },
            ]
          : []
      }
      isLoading={isLoading}
      notFoundTitle={moduleConfig.detail.notFoundTitle}
      notFoundMessage={moduleConfig.detail.notFoundMessage}
      notFoundBackText={moduleConfig.detail.notFoundBackText}
    />
  );
};

export default ClientSummaryPage;
